import { Box, CircularProgress, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

export default function ChartLoadingOverlay(params: {
  loading: boolean;
  children?: ReactNode;
  height?: number | "auto";
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={[
        { position: "relative", height: params.height ?? 400, minWidth: 0 },
        ...(Array.isArray(params.sx) ? params.sx : [params.sx]),
      ]}
    >
      {params.children}
      {params.loading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            backgroundColor: "rgba(255, 255, 255, 0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            "@media print": { display: "none" },
          }}
        >
          <CircularProgress role="status" aria-label="Beräknar..." />
        </Box>
      )}
    </Box>
  );
}
